// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ae-0";
export var optionCard = "_ae-1";